import React, { useState } from 'react'
import './UserBadge.css'

const UserBadge = ({
  user,
  showTitleBadges = true,
  showStatusBadges = true,
  hidePremiumBadge = false,
  context = 'default' // 'default', 'leaderboard', 'hero', 'profile', 'preferences'
}) => {
  // Tooltip state - must be called before any early returns
  const [tooltip, setTooltip] = useState({ show: false, text: '', x: 0, y: 0 })

  if (!user) return null

  const isGM = user?.is_gm
  const isIM = user?.is_im
  const isWFM = user?.is_wfm
  const isPremiumAccount = user?.account_type === 'premium'
  const isStreamer = user?.is_streamer

  // Tooltip handlers (only for profile context)
  const handleMouseEnter = (text) => (e) => {
    if (context === 'profile') {
      setTooltip({ show: true, text, x: e.clientX, y: e.clientY })
    }
  }

  const handleMouseMove = (e) => {
    if (context === 'profile' && tooltip.show) {
      setTooltip(prev => ({ ...prev, x: e.clientX, y: e.clientY }))
    }
  }

  const handleMouseLeave = () => {
    if (context === 'profile') {
      setTooltip({ show: false, text: '', x: 0, y: 0 })
    }
  }

  // Get context-specific CSS classes
  const getPremiumBadgeClass = () => {
    switch (context) {
      case 'leaderboard': return 'leaderboard-premium-badge'
      case 'hero': return 'hero-premium-badge'
      case 'profile': return 'profile-premium-badge'
      case 'preferences': return 'preferences-premium-badge'
      default: return 'user-badge premium-badge'
    }
  }

  const getStreamerBadgeClass = () => {
    switch (context) {
      case 'leaderboard': return 'leaderboard-streamer-badge'
      case 'profile': return 'profile-streamer-badge'
      default: return 'user-badge streamer-badge'
    }
  }

  return (
    <div className="user-badge-container">
      {/* Title badges (GM/IM/WFM) - always before name */}
      {showTitleBadges && (
        <div className="title-badges">
          {isGM && (
            <div className="user-badge gm-badge">GM</div>
          )}
          {isIM && (
            <div className="user-badge im-badge">IM</div>
          )}
          {isWFM && (
            <div className="user-badge wfm-badge">WFM</div>
          )}
        </div>
      )}

      {/* Status badges (Premium/Streamer) - after name */}
      {showStatusBadges && (
        <div className="status-badges">
          {isPremiumAccount && !hidePremiumBadge && (
            <div
              className={getPremiumBadgeClass()}
              onMouseEnter={handleMouseEnter('Premium Account')}
              onMouseMove={handleMouseMove}
              onMouseLeave={handleMouseLeave}
            >★</div>
          )}
          {isStreamer && (
            <div
              className={getStreamerBadgeClass()}
              onMouseEnter={handleMouseEnter('Streamer')}
              onMouseMove={handleMouseMove}
              onMouseLeave={handleMouseLeave}
            ></div>
          )}
        </div>
      )}

      {/* Tooltip */}
      {tooltip.show && (
        <div
          className="badge-tooltip"
          style={{
            left: tooltip.x,
            top: tooltip.y,
          }}
        >
          {tooltip.text}
        </div>
      )}
    </div>
  )
}

export default UserBadge